import { motion } from 'framer-motion'
import { useOrderStore } from '../../store/orderStore'
import './OrderSummary.css'

export default function OrderSummary() {
    const { selectedPackage, developerAccess, network, email, setEmail, promoCode, setPromoCode, getTotalPrice } = useOrderStore()

    const networkFee = 2.5

    const calculateTotal = () => {
        let total = getTotalPrice()
        if (total > 0) {
            total += networkFee
        }
        return total.toFixed(2)
    }

    const hasSelection = selectedPackage || developerAccess

    return (
        <motion.div
            className="order-summary glass"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <div className="summary-header">
                <h3 className="summary-title">Order Summary</h3>
                <div className="live-indicator">
                    <span className="live-dot"></span>
                    <span>Live</span>
                </div>
            </div>

            <div className="summary-content">
                {hasSelection ? (
                    <>
                        <div className="summary-section">
                            <h4 className="section-label">Selected Items</h4>

                            {selectedPackage && (
                                <div className="summary-item-group mb-3">
                                    <div className="summary-item">
                                        <span className="item-label">Package:</span>
                                        <span className="item-value text-neon">{selectedPackage.name}</span>
                                    </div>
                                    <div className="summary-item">
                                        <span className="item-label text-sm text-gray-400">Amount:</span>
                                        <span className="item-value text-sm">{selectedPackage.amount.toLocaleString()} USDT</span>
                                    </div>
                                    <div className="summary-item">
                                        <span className="item-label text-sm text-gray-400">Price:</span>
                                        <span className="item-value text-sm">${selectedPackage.price.toLocaleString()}</span>
                                    </div>
                                </div>
                            )}

                            {developerAccess && (
                                <div className="summary-item-group">
                                    <div className="summary-item">
                                        <span className="item-label">Add-on:</span>
                                        <span className="item-value text-neon-blue">{developerAccess.name}</span>
                                    </div>
                                    <div className="summary-item">
                                        <span className="item-label text-sm text-gray-400">Price:</span>
                                        <span className="item-value text-sm">${developerAccess.price.toLocaleString()}</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="summary-divider"></div>

                        <div className="summary-section">
                            <h4 className="section-label">Delivery Details</h4>
                            <div className="summary-item">
                                <span className="item-label">Network:</span>
                                <span className="item-value network">{network}</span>
                            </div>
                            <div className="summary-item">
                                <span className="item-label">Payment:</span>
                                <span className="item-value">Coinbase Commerce</span>
                            </div>
                        </div>

                        <div className="summary-divider"></div>

                        <div className="summary-section">
                            <h4 className="section-label">Fee Breakdown</h4>
                            <div className="summary-item">
                                <span className="item-label">Subtotal:</span>
                                <span className="item-value">${getTotalPrice().toFixed(2)}</span>
                            </div>
                            <div className="summary-item">
                                <span className="item-label">Network Fee:</span>
                                <span className="item-value">${networkFee.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="summary-divider"></div>

                        <div className="summary-total">
                            <span className="total-label">Total Cost:</span>
                            <span className="total-value text-gradient">${calculateTotal()}</span>
                        </div>
                    </>
                ) : (
                    <div className="no-selection">
                        <span className="no-selection-icon">📦</span>
                        <p>Select a package or add-on to see details</p>
                    </div>
                )}
            </div>

            <div className="summary-actions">
                <div className="email-input-group">
                    <label htmlFor="receipt-email">Email for Receipt (Optional):</label>
                    <input
                        type="email"
                        id="receipt-email"
                        className="email-input"
                        placeholder="your@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>

                <div className="promo-input-group">
                    <input
                        type="text"
                        className="promo-input"
                        placeholder="Promo code"
                        value={promoCode}
                        onChange={(e) => setPromoCode(e.target.value)}
                    />
                    <button className="apply-btn">Apply</button>
                </div>
            </div>

            <div className="summary-footer">
                <div className="security-note">
                    <span className="note-icon">🔒</span>
                    <span>Secure & Encrypted</span>
                </div>
                <div className="support-link">
                    <a href="#">Need help? Contact Support →</a>
                </div>
            </div>
        </motion.div>
    )
}
